import { config } from '../config';
import { addAuthHeader } from './auth';
import logger from "#/utils/logger";

export async function updateSettings(
  language: string,
  muted: boolean,
  machine: string,
  recordingMode: string,
  isMicAlwaysOn: boolean,
  exhibitionMode: boolean,
  serialNumber: number | null | undefined
) {
  const machinePayload: any = {
    machine_display_name: machine,
  };

  // Only send serial_number if caller explicitly wants to update it
  if (serialNumber !== undefined) {
    machinePayload.serial_number = serialNumber; // number or null
  }

  const response = await fetch(`${config.backendUrl}/users/settings`, {
    method: 'PUT',
    headers: await addAuthHeader({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      preferences: {
        language,
        muted,
        recording_mode: recordingMode,
        is_mic_always_on: isMicAlwaysOn,
        exhibition_mode: exhibitionMode,
      },
      machine: machinePayload,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    logger.error("Error response:", errorText);
    throw new Error(
      `HTTP error! status: ${response.status}, message: ${errorText}`
    );
  }

  return await response.json();
}